import { proxy, subscribe } from "valtio"

// function init() {
//   let flag = localStorage.getItem("history")
//   if (!flag) {
//     localStorage.setItem(
//       "history",
//       JSON.stringify({
//         historyList: []
//       })
//     )
//   }
// }
// init()

const historySetup = proxy(
  JSON.parse(localStorage.getItem("history"))
    ? JSON.parse(localStorage.getItem("history"))
    : {
        historyList: []
      }
)
//  添加历史记录
const addHistory = (val) => {
  historySetup.historyList = [...new Set([val, ...historySetup.historyList])]
}
// 移除历史记录
const removeHistory = (val) => {
  let index = historySetup.historyList.indexOf(val)
  historySetup.historyList.splice(index, 1)
}

subscribe(historySetup, (state) => {
  localStorage.setItem("history", JSON.stringify(historySetup))
})

export { addHistory, removeHistory }

export default historySetup
